import { useEffect, useState } from 'react';
import './App.css';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import { Layout } from './components/Layout/Layout';
import { TransceiversView } from './views/Transceivers';
import { UsersView } from './views/Users';
import { AnalyticsView } from './views/Analytics';
import { SearchView } from './views/Search';
import * as api from './api.js';
import { Spinner } from 'react-spinners-css';
import { useGlobalState } from 'hooks';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
    const [urlParamCode, setUrlParamCode] = useState(null);
    const [state, dispatch] = useGlobalState();

    useEffect(() => {
        dispatch.setBusy(true); // *
        const getTokens = async () => {
            const query = new URLSearchParams(window.location.search);
            const code = query.get('code');
            setUrlParamCode(code);
            if (code) {
                const token = await api.sendTokenRequest(code);
                dispatch.setAccessToken(token);
                dispatch.setBusy(false);
            } else {
                api.navigateToLoginPage();
            }
        };
        getTokens(); // *
    }, []);

    if (!urlParamCode) {
        return <div className="App"><ProgressIndicator /></div>;
    }

    return (
        <div className="App">
            <div className="app_main_cont">
                <Router>
                    <Switch>
                        <Route exact path="/">
                            <Layout infobar='path'>
                                <TransceiversView />
                            </Layout>
                        </Route>
                        <Route exact path="/transceivers">
                            <Layout infobar='path'>
                                <TransceiversView />
                            </Layout>
                        </Route>
                        <Route exact path="/users">
                            <Layout>
                                <UsersView />
                            </Layout>
                        </Route>
                        <Route exact path="/search">
                            <Layout>
                                <SearchView />
                            </Layout>
                        </Route>
                    </Switch>
                </Router>
            </div>
            <ProgressIndicator />
        </div>
    );
}

function ProgressIndicator() {
    const [state, dispatch] = useGlobalState();

    if (!state.busy) {
        return null;
    }

    return (
        <div style={{ position: 'absolute', top: '30%', zIndex: '2000' }}>
            <Spinner size={200} color={'black'} />
        </div>
    );
}

export default App;
